import { SelectOption } from '@rio-cloud/rio-uikit/Select';
import { VehicleType } from '../common.types';
import { FormattedMessage } from 'react-intl';
import { FilterModalSelect } from './FilterModal';
import { ModalFilterProps } from './ModalFilterProps';

export const getVehicleTypeOptions = (): SelectOption[] => {
    return Object.values(VehicleType).map((type) => ({
        id: type,
        label: <FormattedMessage id={`outboundOrderBook.common.vehicleType.${type.valueOf()}`} />,
    }));
};

export const DispatchTypeFilter = <T extends { vehicleTypeFilter?: string | undefined }>({
    localFilters,
    setLocalFilters,
}: ModalFilterProps<T>) => {
    return (
        <FilterModalSelect
            labelMessageId="outboundOrderBook.common.filter.dispatchType"
            inputAddon="rioglyph rioglyph-car"
            placeholderMessageId="outboundOrderBook.common.filter.selectDispatchType"
            isOptional
            options={getVehicleTypeOptions()}
            value={localFilters.vehicleTypeFilter}
            onChange={(item) => {
                setLocalFilters((prevState) => ({
                    ...prevState,
                    vehicleTypeFilter: item?.id,
                }));
            }}
        />
    );
};
